import {
  AccessRequestTemplateTypeClientModel,
  ResourceFilterType,
  useCreateAccessRequestTemplate,
} from '@client-app-sdk';
import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { ConfirmDialogWithInput } from '@common/ui/ConfirmDialog';
import { ensureArray, FormState } from '@MyRequests/helpers';
import { AnalyticsEvents } from '@common/utils/analytics/events';

function TemplateCTA({ formState, disable }: { formState: FormState; disable: boolean }) {
  const { createRequestTemplate, isLoading, isError, isSuccess, error } = useCreateAccessRequestTemplate();
  const [open, setOpen] = useState(false);

  const isFormDataEmpty = !(
    formState.selectedIntegration?.value !== undefined &&
    formState.selectedResourceType?.value !== undefined &&
    formState.selectedResource?.length !== 0 &&
    (formState.selectedPermission?.value !== undefined || formState.selectedMultiplePermission?.length !== 0)
  );

  useEffect(() => {
    if (isSuccess) {
      toast.success('Favorite saved successfully');
      setOpen(false);
    }
  }, [isSuccess, isError, error]);

  const handleSaveTemplate = (name: string) => {
    if (isFormDataEmpty) return;
    // TODO: adjust favorites to accept search_term in resources
    const resourceIds = formState.selectedResource
      ?.filter((r) => r.value.startsWith(ResourceFilterType.Id))
      .map((r) => r.value.split(':')[1]);

    createRequestTemplate({
      createAndUpdateAccessRequestTemplateClientModel: {
        name,
        type: AccessRequestTemplateTypeClientModel.IntegrationRequest,
        filter_integration_ids: ensureArray(formState.selectedIntegration?.value ?? []),
        filter_resource_type_ids: ensureArray(formState.selectedResourceType?.value ?? []),
        filter_resource_ids: ensureArray(resourceIds ?? []),
        filter_permission_ids: ensureArray(
          formState.selectedPermission?.value ?? formState.selectedMultiplePermission?.map((p) => p.value) ?? [],
        ),
      },
    });
    setOpen(false);
  };

  return (
    <>
      <LoadingButton
        data-trigger={AnalyticsEvents.TemplateSaveClicked}
        loading={isLoading}
        onClick={() => setOpen(true)}
        disabled={disable || isFormDataEmpty}
      >
        Add to Favorites
      </LoadingButton>
      <ConfirmDialogWithInput
        inputProps={{ label: '', placeholder: 'Favorite name' }}
        onConfirm={handleSaveTemplate}
        open={open}
        onClose={() => setOpen(false)}
        confirmLabel="Add to Favorites"
        disproveLabel="Cancel"
        maxWidth="xs"
      >
        <Typography variant="body2">Name this saved favorite:</Typography>
      </ConfirmDialogWithInput>
    </>
  );
}

export default TemplateCTA;
